import { useState, useEffect, useRef } from 'react';
import { CButton, CCol, CRow, CInput, CTabs, CNav, CNavItem, CNavLink, CLabel, CSelect, CFormGroup, CModal, CModalHeader, CModalTitle, CModalFooter, CModalBody, CTextarea, CCard, CCardHeader, CCardBody, CTooltip } from '@coreui/react';

import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import { useReactToPrint } from 'react-to-print';
import ThingsToConsider from '../aimhi-widgets/ThingToConsider';
import PrintEquipmentRequest from './PrintEquipmentRequest';
import $axios from 'src/utils/axios';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import IP from '../../StoreGlobal/IP';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDateToMMDDYYYY } from 'src/utils/dateUtils';
import { useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { FaPencilAlt, FaAngleDown, FaAngleRight } from 'react-icons/fa';
import { EquipmentRequestHistoryEdit, GetTotalFuelOrder, GetEquipmentByCategory, PostEquipmentRequestV2 } from 'src/request/Equipment';
import useCheckPermission from 'src/utils/useCheckPermission';
import { showError } from 'src/utils/swalError';
import { useParams } from 'react-router-dom';
import ProjectTabs from '../projects/ProjectTabs';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';
import EquipmentAssign from './EquipmentAssign';
import Select, { components } from 'react-select';
import { CancelEquipmentRequest } from 'src/request/Projects';

let fuel_data = [
  {
    category: 'Diesel',
    total_ordered: 0,
    liters: null,
    unit_price: null,
    total_price: null,
    supplier: null,
    date_deployment: null,
    notes: null,
  },
  {
    category: 'Gasoline',
    total_ordered: 0,
    liters: null,
    unit_price: null,
    total_price: null,
    supplier: null,
    date_deployment: null,
    notes: null,
  },
  {
    category: 'Kerosene',
    total_ordered: 0,
    liters: null,
    unit_price: null,
    total_price: null,
    supplier: null,
    date_deployment: null,
    notes: null,
  },
  {
    category: 'Oil',
    total_ordered: 0,
    liters: null,
    unit_price: null,
    total_price: null,
    supplier: null,
    date_deployment: null,
    notes: null,
  },
  {
    category: 'Lubricant',
    total_ordered: 0,
    liters: null,
    unit_price: null,
    total_price: null,
    supplier: null,
    date_deployment: null,
    notes: null,
  },
];

const Equipment = () => {
  const Swal = require('sweetalert2');
  const { id: projectID } = useParams();
  const projectInfo = useSelector((state) => state.project.projectInfo[projectID]);
  const company_id = parseInt(localStorage.getItem('company_id'));
  let accessToken = localStorage.getItem('token');
  let user_id = parseInt(localStorage.getItem('user_id'));
  const checkPermission = useCheckPermission();
  const [requestedEquipments, setRequestedEquipments] = useState({});
  const [active, setActive] = useState(1);
  const [modal, setModal] = useState(false);
  const [equipmentList, setequipmentList] = useState([]);
  const [modalEmail, setmodalEmail] = useState(false);
  const [email, setemail] = useState('');
  const [projectstart, setprojectStart] = useState('');
  const [projectend, setprojectend] = useState('');
  const [requestHistory, setRequestHistory] = useState([]);
  const [fuel, setFuel] = useState([]);
  const [modalBrandsList, setModalBrandsList] = useState([]);
  const [modalCategoryList, setModalCategoryList] = useState([]);
  const [categoryValue, setCategoryValue] = useState([]);
  const [printCategory, setPrintCategory] = useState('');
  const [fuelRequest, setFuelRequest] = useState({});
  const [clickPrintNotif, setClickPrintNotif] = useState(false);
  const [equipmentRequest, setequipmentRequest] = useState({});
  const [toggle, settoggle] = useState([]);
  const [isCreatingRequest, setIsCreatingRequest] = useState(false);
  const [activePRId, setActivePRId] = useState(null);

  const EquipmentOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="flex flex-col">
          <div className="uppercase">{props.data.label}</div>
          <div className='text-xs text-gray-600'>{props.data.brand_name}</div>
          <div className='text-xs text-gray-600'>{props.data.model_name}</div>
        </div>
      </components.Option>
    );
  };

  useEffect(() => {
    setFuel(fuel_data);
    setprojectStart(new Date(projectInfo?.start_date));
    setprojectend(new Date(projectInfo?.end_date));
    gitequipment(projectID);
    CategoryList();
    BrandList();
    gitRequstHistory();
    requestFuelTotalorder(projectID);
  }, []);

  useEffect(() => {
    resetFuelState();
  }, [active]);

  if ('matchMedia' in window) {
    // Chrome, Firefox, and IE 10 support mediaMatch listeners
    window.matchMedia('print').addListener(function (media) {
      if (media.matches) {
        beforePrint();
      } else {
        afterPrint();
      }
    });
  } else {
  }

  const beforePrint = () => {
    setClickPrintNotif(true);
  };

  const afterPrint = () => {
    setClickPrintNotif(false);
  };


  const requestFuelTotalorder = (projectId) => {
    GetTotalFuelOrder(projectId).then((res) => {
      if (res.data.status == 200) {
        let fuelResponse = res.data.response;
        let fuelData = JSON.parse(JSON.stringify(fuel_data));
        for (let i = 0; i < fuelData.length; i++) {
          fuelData[i].total_ordered = fuelResponse[fuelData[i].category] || 0;
        }
        setFuel(fuelData);
      }
    });
  };

  const gitRequstHistory = () => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios.get(`equipment/request-history/${company_id}/${projectID}?limit=${-1}`).then((res) => {
      if (res.data.status == 200) {
        setRequestHistory(res.data.response.data);
      }
    });
  };

  const gitequipment = (project_id) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .get(`equipment/project/list/${company_id}/${project_id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setequipmentList(res.data.response);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const CategoryList = () => {
    let company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .post(IP + 'equipment/category', {
        company_id: company_id,
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setModalCategoryList(res.data.response);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const BrandList = () => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .post('equipment/list/brands', {
        company_id: company_id,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setModalBrandsList(res.data.response);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });



  const requestOnchange = (e, counter) => {
    let updatedEquipmentList = [...equipmentList];
    let index = updatedEquipmentList.findIndex((item) => item.details.some((detail) => detail.counter === counter));
    let value = e.target.checked ? 1 : 0;

    let updatedDetails = updatedEquipmentList[index].details.map((detail) => {
      if (detail.counter === counter) {
        return {
          ...detail,
          request: value,
        };
      }
      return detail;
    });

    let updatedItem = {
      ...updatedEquipmentList[index],
      details: updatedDetails,
    };

    let updatedList = [...updatedEquipmentList];
    updatedList[index] = updatedItem;
    setequipmentList(updatedList);
  };

  const datestartOnchange = (dates, counter) => {
    let updatedEquipmentList = [...equipmentList];
    let index = updatedEquipmentList.findIndex((item) => item.details.some((detail) => detail.counter === counter));

    let updatedDetails = updatedEquipmentList[index].details.map((detail) => {
      if (detail.counter === counter) {
        return {
          ...detail,
          date_start: formatDateToMMDDYYYY(dates),
        };
      }
      return detail;
    });

    let updatedItem = {
      ...updatedEquipmentList[index],
      details: updatedDetails,
    };

    let updatedList = [...updatedEquipmentList];
    updatedList[index] = updatedItem;
    setequipmentList(updatedList);
  };

  const dateendOnchange = (dates, counter) => {
    let updatedEquipmentList = [...equipmentList];
    let index = updatedEquipmentList.findIndex((item) => item.details.some((detail) => detail.counter === counter));

    let updatedDetails = updatedEquipmentList[index].details.map((detail) => {
      if (detail.counter === counter) {
        return {
          ...detail,
          date_end: formatDateToMMDDYYYY(dates),
        };
      }
      return detail;
    });

    let updatedItem = {
      ...updatedEquipmentList[index],
      details: updatedDetails,
    };

    let updatedList = [...updatedEquipmentList];
    updatedList[index] = updatedItem;
    setequipmentList(updatedList);
  };

  const subnewequipment = () => {

    let arr = [...equipmentList];
    let arr_length = equipmentList.length;
    arr.push({
      category_id: categoryValue.value,
      counter: arr_length + 1,
      equipment: categoryValue.label,
      description: '',
      rental: 0,
      location: '',
      date_start: '',
      date_end: '',
      request: 0,
      equipment_details: [],
      unavailable_date: [],
    });

    setequipmentList(arr);

    setModal(false);
  };

  const handleFetchEquipmentByCategory = (categoryId, itemIndex, dIndex) => {
    GetEquipmentByCategory({ categoryId }).then((res) => {
      if (res.data.status == 200) {
        let updatedEquipmentList = [...equipmentList];
        let models = res.data.data_list.map((item) => ({
          label: item.eq_number,
          value: item.eq_number,
          eq_id: item.eq_id,
          brand_id: item.brand_id,
          brand_name: item.brand_name,
          model_id: item.model_id,
          model_name: item.model_name,
          location: item.location,
          rental: item.rental,
          unavailable_date: item.unavailable_date,
        }));

        updatedEquipmentList[itemIndex].details[dIndex].equipment_details = models;
        setequipmentList(updatedEquipmentList);
      }
    });
  };

  const resetFuelState = () => {
    const initialFuelState = fuel.map((item) => ({
      ...item,
      liters: null,
      unit_price: null,
      total_price: null,
      supplier: null,
      date_deployment: null,
      notes: null,
    }));

    setFuel(initialFuelState);
  };

  const createarequest = (type) => {
    Swal.fire({
      title: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Save',
      confirmButtonColor: '#23303d',
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          project_id: parseInt(projectID),
          company_id: company_id,
          user_id: user_id,
          type: type,
          request: [],
        };
        if (type == 'Fuel') {
          let arr = [...fuel];

          let filter = arr.filter((a) => a.liters != null && a.unit_price != null);
          for (var i in filter) {
            data.request.push({
              category: filter[i].category,
              liters: parseFloat(filter[i].liters),
              unit_price: parseFloat(filter[i].unit_price),
              total_price: filter[i].total_price,
              supplier: filter[i].supplier,
              date_deployment: filter[i].date_deployment,
              notes: filter[i].notes,
            });
          }
        } else {
          let arr = [...equipmentList];
          let request = { ...requestedEquipments };
          let requestData = [];

          for (let index in request) {
            for (let detailIndex in request[index]) {
              if (request[index][detailIndex].isChecked) {
                const equipmentIndex = request[index][detailIndex].index;

                const selectedEquipment = arr[index].details[detailIndex].equipment_details[equipmentIndex];
                requestData.push({
                  brand: selectedEquipment.brand_name,
                  brand_id: selectedEquipment.brand_id,
                  category: arr[index].equipmentName,
                  category_id: arr[index].details[detailIndex].category_id,
                  date_end: arr[index].details[detailIndex].date_end,
                  date_start: arr[index].details[detailIndex].date_start,
                  equipment_id: selectedEquipment.eq_id,
                  rental: arr[index].details[detailIndex].rental,
                  psow_id: arr[index].details[detailIndex].psow_id,
                  pe_id: arr[index].details[detailIndex].pe_id,
                });
              }
            }
          }
          data.request = requestData;
        }

        setIsCreatingRequest(true);
        PostEquipmentRequestV2(data)
          .then((res) => {
            const mixpanelData = data?.request?.map(req => {
              return {
                project_id: data.project_id,
                company_id: data.company_id,
                user_id: data.user_id,
                type: data.type,
                brand: req.brand,
                brand_id: req.brand_id,
                equipment_name: req.category,
                category_id: req.category_id,
                date_start: req.date_start,
                date_end: req.date_end,
                eq_id: req.eq_id,
                rental: req.rental,
                psow_id: req.psow_id,
                pe_id: req.pe_id
              }
            })
            if (res.data.status != 200) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: res.data.message,
                confirmButtonColor: '#23303D',
              });
            } else {
              mixpanelData.forEach((item) => {
                trackEvent(mixPanelEvents.REQUEST_EQUIPMENT, {
                  'Source': 'Project - Equipment',
                  ...item,
                });
              });
              resetFuelState();
              gitequipment(projectID);
              requestFuelTotalorder(projectID);
              gitRequstHistory();
              setActive(3);
              Swal.fire('Saved!', '', 'success');
              setRequestedEquipments({});
            }
          })

          .catch((error) => {
            if (error?.response?.status === 403) {
              showError(error?.response?.data?.response, "Permission Denied");
              return;
            }
            console.error(error);
          })
          .finally(() => {
            setIsCreatingRequest(false);
          });
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    });
  };

  const saveDateDelivered = (e, index, id, pr_num, remarks) => {
    let data = {
      id: id,
      pr_num: pr_num,
      updates: {
        remarks: remarks,
      },
    };

    EquipmentRequestHistoryEdit(company_id, projectID, data).then((res) => {
      if (res.data.status == 1) {
        let arr = [...requestHistory];

        arr[index]['edit'] = false;

        setRequestHistory(arr);
      }
    });
  };

  const validateInput = (enteredValue) => {
    const isValid = enteredValue === '' || (/^\d*\.?\d*$/.test(enteredValue) && parseFloat(enteredValue) >= 0);
    const hasScientificNotation = /[eE]/.test(enteredValue);

    return isValid && !hasScientificNotation;
  };

  const fuelQuantityChange = (e, Index) => {
    let arr = [...fuel];
    const isValid = validateInput(e.target.value);
    if (isValid) {
      arr[Index].liters = e.target.value;
      setFuel(arr);
    } else {
      arr[Index].liters = 0;
      Swal.fire({ icon: 'error', title: 'Invalid input', text: 'Please enter a valid positive number' });
      setFuel(arr);
    }
  };

  const unitPriceChange = (e, Index) => {
    let arr = [...fuel];
    const isValid = validateInput(e.target.value);
    if (isValid) {
      arr[Index].unit_price = e.target.value;
      setFuel(arr);
    } else {
      arr[Index].unit_price = 0;
      Swal.fire({ icon: 'error', title: 'Invalid input', text: 'Please enter a valid positive number' });
      setFuel(arr);
    }
  };

  const supplierChange = (e, Index) => {
    let arr = [...fuel];
    arr[Index].supplier = e.target.value;

    setFuel(arr);
  };

  const deploymnentDateChange = (e, Index) => {
    let arr = [...fuel];
    arr[Index].date_deployment = e.target.value;

    setFuel(arr);
  };

  const notesChange = (e, Index) => {
    let arr = [...fuel];
    arr[Index].notes = e.target.value;

    setFuel(arr);
  };

  const FuelTable = fuel.map((fuel, Index) => {
    let total_price = (fuel.liters * fuel.unit_price).toFixed(2);
    return (
      <tr key={Index}>
        <td>{fuel.category}</td>
        <td>{fuel.total_ordered}</td>
        <td>
          <CInput type="text" inputMode="numeric" value={fuel.liters} onChange={(e) => fuelQuantityChange(e, Index)} />
        </td>
        <td>
          <CInput type="text" inputMode="numeric" value={fuel.unit_price} onChange={(e) => unitPriceChange(e, Index)} />
        </td>
        <td>{total_price}</td>
        <td>
          <CInput type="text" value={fuel.supplier} onChange={(e) => supplierChange(e, Index)} />
        </td>
        <td>
          <CInput type="date" value={fuel.date_deployment} onChange={(e) => deploymnentDateChange(e, Index)} />
        </td>
        <td>
          <CInput type="text" value={fuel.notes} onChange={(e) => notesChange(e, Index)} />
        </td>
      </tr>
    );
  });

  const EquipmentOnchange = (opt) => {
    setCategoryValue(opt);
  };

  const createOptionEquipment = (opt) => {
    let arr = [...modalCategoryList];
    arr.push({ label: opt, value: -1 });
    setCategoryValue({ label: opt, value: -1 });
    setModalCategoryList(arr);
  };


  const send = () => {
    $axios
      .post('equipment/sentmail', {
        receiver: email,
        equipment_request: equipmentRequest,
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setmodalEmail(false);
          Swal.fire({
            icon: 'success',
            title: 'Email already sent',
            showConfirmButton: false,
          });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };


  const clickPrint = (
    project_id,
    pr_number,
    category,
    pr_id
  ) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios.get(`equipment/request-history/details/${company_id}/${project_id}/${pr_number}?category=${category}`).then((res) => {
      setPrintCategory(category);

      if (category == 'Fuel') {
        setFuelRequest(res.data.response.data);
      } else {
        setequipmentRequest(res.data.response.data);
      }
    });
    setActivePRId(pr_id);
    setActive(4);
  };

  const clickEdit = (Index) => {
    let arr = [...requestHistory];
    arr[Index]['edit'] = true;
    setRequestHistory(arr);
  };

  const remarks = (e, Index) => {
    let arr = [...requestHistory];
    arr[Index]['remarks'] = e.target.value;
    setRequestHistory(arr);
  };

  const ErHistory = requestHistory.map((data, Index) => {
    let color = '#25C6E3';
    if (data['approval_status'] == 'Approved') {
      color = '#3A7D21';
    } else if (data['approval_status'] == 'Disapproved') {
      color = '#B42A19';
    }
    return (
      <tr key={Index}>
        <td>{Index + 1}</td>
        <td>{data.pr_number}</td>
        <td>{data.category}</td>
        <td>{data.preparer}</td>
        <td>{data.request_date}</td>
        <td>
          <CCol style={{ padding: '0' }}>
            <CRow>
              <CCol xl="10">
                <CTextarea
                  onChange={(e) => remarks(e, Index)}
                  onBlur={(e) => saveDateDelivered(e, Index, data.id, data.pr_number, data.remarks)}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      saveDateDelivered(e, Index, data.id, data.pr_number, data.remarks);
                    }
                  }}
                  value={data['remarks']}
                  disabled={data.edit != true}
                ></CTextarea>
              </CCol>
              <CCol xl="2">
                <FaPencilAlt onClick={() => clickEdit(Index)} />
              </CCol>
            </CRow>
          </CCol>
        </td>
        <td style={{ color: color }}>{data['approval_status']}</td>
        <td>
          <CButton
            variant="outline"
            block
            color="aimhi-primary"
            onClick={() =>
              clickPrint(
                projectID,
                data.pr_number,
                data.category,
                data.id
              )
            }
          >
            View
          </CButton>
        </td>
      </tr>
    );
  });

  const toggleShow = (value) => {
    const shownState = toggle.slice();
    const index = shownState.indexOf(value);
    if (index >= 0) {
      shownState.splice(index, 1);
      settoggle(shownState);
    } else {
      shownState.push(value);
      settoggle(shownState);
    }
  };

  const updateRequestedEquipments = ({ index, detailIndex, equipmentDetailIndex, type, isChecked = false }) => {
    let request = { ...requestedEquipments };

    if (!(index in request)) {
      request[index] = {};
    }

    if (!(detailIndex in request[index])) {
      request[index][detailIndex] = {};
    }

    if (type == 'brand') {
      request[index][detailIndex]['index'] = equipmentDetailIndex;
    } else if (type == 'checkbox') {
      request[index][detailIndex].isChecked = isChecked;
    }

    setRequestedEquipments(request);
  };

  const listOfEquipments = equipmentList.map((item, Index) => {
    const tbody = item.details.map((detail, detailIndex) => {
      let startDate = detail.date_start == '' ? detail.date_start : new Date(Date.parse(detail.date_start));
      let endDate = detail.date_end == '' ? detail.date_end : new Date(Date.parse(detail.date_end));
      let arr_date = [...detail.unavailable_date];
      let arr_futa = [];
      for (var i in arr_date) {
        let start_futa = new Date(arr_date[i].date_start);
        let end_futa = new Date(arr_date[i].date_end);
        while (start_futa <= end_futa) {
          arr_futa.push(new Date(start_futa));
          start_futa.setDate(start_futa.getDate() + 1);
        }
      }

      const validateCheckboxSelection = (isChecked, detail) => {
        if (!isChecked) return true;

        const missingFields = [];

        if (!detail.description) {
          missingFields.push('Model');
        }

        if (!detail.date_start) {
          missingFields.push('Date Start');
        }

        if (!detail.date_end) {
          missingFields.push('Date End');
        }

        if (missingFields.length > 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Missing Required Fields',
            text: `Please select the following before you can request this equipment: ${missingFields.join(', ')}`,
            confirmButtonColor: '#23303D',
            confirmButtonText: 'OK'
          });
          return false;
        }

        return true;
      };
      return (
        <tr key={detailIndex}>
          <td style={{ textAlign: 'center' }}>
            {' '}
            <input
              type="checkbox"
              className="transform scale-150"
              onChange={(e) => {
                const isValid = validateCheckboxSelection(e.target.checked, detail);
                if (isValid) {
                  requestOnchange(e, detail.counter);
                  updateRequestedEquipments({
                    index: Index,
                    detailIndex: detailIndex,
                    type: 'checkbox',
                    isChecked: e.target.checked
                  });
                } else {
                  e.target.checked = false;
                }
              }}
              disabled={!checkPermission('/equipment/request')}
            />
          </td>
          <td>{detail.sow}</td>
          <td>{detail.work_item}</td>
          <td>
            {' '}
            <Select
              size="sm"
              value={detail.equipment_details.find((opt) => opt.value === detail.description) || null}
              placeholder="Select"
              options={detail.equipment_details}
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: '160px',
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              onMenuOpen={() => handleFetchEquipmentByCategory(detail.category_id, Index, detailIndex)}
              onChange={(selectedOption) => {
                const updatedEquipmentList = [...equipmentList];
                updatedEquipmentList[Index].details[detailIndex] = {
                  ...updatedEquipmentList[Index].details[detailIndex],
                  description: selectedOption?.value || '',
                  brand: selectedOption?.brand_name || '',
                  brand_id: selectedOption?.brand_id || '',
                  equipment_id: selectedOption?.eq_id || '',
                  location: selectedOption?.location || '',
                  rental: selectedOption?.rental || 0,
                  unavailable_date: selectedOption?.unavailable_date || [],
                };
                setequipmentList(updatedEquipmentList);

                const equipmentDetailIndex = detail.equipment_details.findIndex(
                  (opt) => opt.value === selectedOption?.value
                );
                updateRequestedEquipments({
                  index: Index,
                  detailIndex: detailIndex,
                  equipmentDetailIndex: equipmentDetailIndex,
                  type: 'brand',
                });
              }}
              isDisabled={!checkPermission('/equipment/request')}
              components={{ Option: EquipmentOption }}
            />
          </td>
          <td>{detail.location}</td>
          <td>
            {' '}
            <DatePicker
              selected={startDate}
              onChange={(date) => datestartOnchange(date, detail.counter)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              excludeDates={arr_futa}
              minDate={projectstart}
              dateFormat="MM/dd/yyyy"
              placeholderText="mm/dd/yyyy"
              className="px-2 border-2 border-black"
              disabled={!checkPermission('/equipment/request')}
            />
          </td>
          <td>
            {' '}
            <DatePicker
              selected={endDate}
              onChange={(date) => dateendOnchange(date, detail.counter)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              excludeDates={arr_futa}
              minDate={projectstart}
              className="px-2 border-2 border-black"
              dateFormat="MM/dd/yyyy"
              placeholderText="mm/dd/yyyy"
              disabled={!checkPermission('/equipment/request')}
            />
          </td>
          <td style={{ textAlign: 'center' }}>{detail.rental === 1 ? 'Yes' : 'No'}</td>
          <td style={{ textAlign: 'center' }}>{detail.request_count}</td>
        </tr>
      );
    });
    return (
      <CCard key={Index}>
        <CCardHeader onClick={() => toggleShow(item.equipmentName)}>
          <span>{toggle.includes(item.equipmentName) ? <FaAngleDown style={{ width: '25px', height: '25px' }} /> : <FaAngleRight style={{ width: '25px', height: '25px' }} />}</span>
          <span style={{ fontFamily: 'Roboto', fontWeight: 'bold', marginLeft: '10px' }}>{item.equipmentName}</span>
        </CCardHeader>
        <div className={`transition-all duration-300 ease-in-out opacity-100 ${toggle.includes(item.equipmentName) ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`}>
          <CCardBody style={{ minHeight: '400px', maxHeight: '500px', overflow: 'auto' }}>
            <div className="table-responsive" style={{ minHeight: '400px', maxHeight: '500px', overflow: 'auto', paddingBottom: '150px' }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Request</th>
                    <th>Scope of Work</th>
                    <th>Work Item</th>
                    <th>Equipment No.</th>
                    <th>Location</th>
                    <th>Date Start</th>
                    <th>Date End</th>
                    <th>Rental</th>
                    <th>Requests</th>
                  </tr>
                </thead>
                <tbody>{tbody}</tbody>
              </table>
            </div>
          </CCardBody>
        </div>
      </CCard>
    );
  });

  if (clickPrintNotif == true) {
    return (
      <CCol>
        <span style={{ fontSize: '25px', fontWeight: 'Bold' }}>Please use print request button to print!!</span>
      </CCol>
    );
  }


  const hasCheckedEquipment = () => {
    return Object.values(requestedEquipments).some(equipmentCategory =>
      Object.values(equipmentCategory).some(detail =>
        detail?.isChecked === true
      )
    );
  };

  const handleTabNavigate = (idx, name) => {
    setActive(idx)

    trackEvent(`Click to Project - Equipment - ${name}`, {
      'Source': "Project - Equipment",
      'AIMHI Version': 1,
    })
  }

  const handleCancelRequest = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to cancel this request?',
      icon: 'warning',
      showCancelButton: true,
    });

    if (!result.isConfirmed) return;

    try {
      const res = await CancelEquipmentRequest(Number(activePRId));

      if (res.status === 200) {
        Swal.fire({
          title: 'Success',
          icon: 'success',
          text: 'Request cancelled successfully.',
        });

        setActivePRId(null);
        setActive(3);
      }
    } catch (error) {
      if (error.response?.status === 400) {
        Swal.fire({
          title: 'Oops',
          icon: 'error',
          text: error.response?.data?.message || 'Something went wrong. Please try again.',
        });
      } else {
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: 'Something went wrong. Please try again.',
        });
      }

      console.error(error);
    } finally {
      gitRequstHistory(projectID);
    }
  };
  return (
    <>
      <ProjectTabs />
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="12" xl="9" style={{ marginTop: '20px' }}>
          <CTabs>
            <CNav variant="tabs" className="!border-b-[6px]">
              <CNavItem>
                <CNavLink className={active == 1 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(1, 'Equipment List')}>
                  Equipment
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active === 5 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(5, 'Assign')}>
                  Assign
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active == 2 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(2, 'Fuel')}>
                  Fuel
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active == 3 || active == 4 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(3, 'Request History')}>
                  Request History
                </CNavLink>
              </CNavItem>
            </CNav>
            {active == 1 && (
              <CCol style={{ marginTop: '20px' }}>
                <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                  <CRow>
                    <CCol xs="12" sm="12" md="12" lg="10"></CCol>
                    <CCol xs="12" sm="12" md="12" lg="2">
                      {checkPermission('/equipment/request') && (
                        <>
                          {!hasCheckedEquipment() ? (
                            <CTooltip content="You must first request equipment by toggling the checkbox.">
                              <span className="w-full">
                                <CButton
                                  block
                                  color="aimhi-primary"
                                  size="sm"
                                  onClick={() => createarequest('Equipment')}
                                  disabled
                                >
                                  Create Request
                                </CButton>
                              </span>
                            </CTooltip>
                          ) : (
                            <CButton
                              block
                              color="aimhi-primary"
                              size="sm"
                              onClick={() => createarequest('Equipment')}
                              disabled={isCreatingRequest}
                            >
                              {isCreatingRequest ? 'Creating Request' : 'Create Request'}
                            </CButton>
                          )}
                        </>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
                <CCol xs="12" sm="12" md="12" lg="12" style={{ padding: '10px', marginTop: '20px', overflow: 'auto' }}>
                  {listOfEquipments}
                </CCol>
              </CCol>
            )}
            {active == 2 && (
              <CCol xs="12" sm="12" md="12" style={{ padding: '0px' }}>
                <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                  <CRow>
                    <CCol xs="12" sm="12" md="12" lg="8"></CCol>
                    <CCol xs="12" sm="12" md="12" lg="2">
                    </CCol>
                    <CCol xs="12" sm="12" md="12" lg="2">
                      {checkPermission('/equipment/request') && (
                        <CButton block color="aimhi-primary" size="sm" onClick={() => createarequest('Fuel')} disabled={isCreatingRequest}>
                          {isCreatingRequest ? 'Saving...' : 'Create request'}
                        </CButton>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
                <div className="table-responsive">
                  <table className="table" style={{ marginTop: '10px' }}>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Total Ordered</th>
                        <th>Quantity (Liters)</th>
                        <th>Unit Price</th>
                        <th>Total Price</th>
                        <th>Supplier</th>
                        <th>Deployment Date</th>
                        <th>Notes</th>
                      </tr>
                    </thead>
                    <tbody>{FuelTable}</tbody>
                  </table>
                </div>
              </CCol>
            )}

            {active == 3 && (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>ER Number</th>
                      <th>Category</th>
                      <th>Preparer</th>
                      <th>Request Date</th>
                      <th>Remarks</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{ErHistory}</tbody>
                </table>
              </div>
            )}

            {active == 4 && (
              <CCol style={{ padding: '0px' }}>
                <CRow>
                  <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
                    <CRow>
                      <CCol xs="12" sm="12" md="12" lg="6"></CCol>
                      <CCol xs="12" sm="12" md="12" lg="2">
                        {checkPermission('/equipment/request-history') && (
                          <CButton variant="outline" color="aimhi-textlight-neutral" size="sm" block onClick={() => handleCancelRequest()}>
                            <span>Cancel request</span>
                          </CButton>
                        )}
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="2">

                        {checkPermission('/equipment/request-history') && (
                          <CButton variant="outline" color="aimhi-textlight-neutral" size="sm" block onClick={handlePrint}>
                            <span>Print request</span>
                          </CButton>
                        )}
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="2">
                        {checkPermission('/equipment/sentmail') && (
                          <CButton variant="outline" color="aimhi-textlight-neutral" size="sm" block onClick={() => setmodalEmail(true)}>
                            <span>Email request</span>
                          </CButton>
                        )}
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol xs="12" sm="12" md="12" lg="12">
                    <PrintEquipmentRequest
                      ref={componentRef}
                      equipment={equipmentRequest}
                      fuel={fuelRequest}
                      category={printCategory}
                      project_name={projectInfo?.project_name}
                      project_id={projectID}
                    />
                  </CCol>
                </CRow>
              </CCol>
            )}
            {active === 5 && (
              <EquipmentAssign onRefreshHistory={gitRequstHistory} />
            )}
          </CTabs>
        </CCol>

        <CCol xs="12" sm="12" md="12" lg="12" xl="3">
          {active != 4 && <ThingsToConsider />}
        </CCol>
      </CRow>

      <CModal show={modal} onClose={() => setModal(!modal)} size="lg" style={{ borderRadius: '10px' }}>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>Add Equipment</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Equipment Category</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <CreatableSelect value={categoryValue} options={modalCategoryList} onChange={(opt, meta) => EquipmentOnchange(opt, meta)} onCreateOption={(opt, meta) => createOptionEquipment(opt, meta)} />
                </td>
              </tr>
            </tbody>
          </table>
        </CModalBody>
        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton
              variant="outline"
              block
              color="aimhi-textlight-neutral"
              size="sm"
              onClick={() => subnewequipment()}
            >
              Submit
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>

      <CModal show={modalEmail} onClose={() => setmodalEmail(!modalEmail)} style={{ borderRadius: '5px' }}>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>SEND E-MAIL</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol md="12" sm="12" lg="12" xl="12">
            <CFormGroup row>
              <CLabel sm="2" col="sm" htmlFor="input-small">
                TO:
              </CLabel>
              <CCol sm="6">
                <CInput size="sm" type="email" id="input-small" className="input-sm" placeholder="example@gmail.com" value={email} onChange={(e) => setemail(e.target.value)} />
              </CCol>
            </CFormGroup>
          </CCol>
        </CModalBody>
        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton block color="aimhi-primary" size="sm" onClick={() => send()} disabled={email == ''}>
              SEND
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default Equipment;
